<template>
  <section
    ref="section9"
    class="mx-auto flex  h-full flex-col"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="10"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
    
      <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
          <div><v-icon icon="list-clock" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mr-6 text-heading-3-desktop">
              Status gradnje vaše nepremičnine
            </div>
          </div>
          <v-lightbox is-authenticated footerless>
            <template v-slot:trigger>
                <div
                    class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                >
                    <v-icon icon="question-mark" size="4"></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <div class="flex items-start">
                    <v-icon
                        icon="question-mark"
                        class="mr-2.5"
                        size="4.5"
                    ></v-icon>
                    <div>
                        Dodatne informacije
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <p class="mb-[10px] text-icon-text-medium">
                    Zgrajeno
                </p>
                <p class="mb-8 text-body-regular">
                    To možnost izberite, če se gre za že zgrajeno nepremičnino z uporabnim dovoljenjem.
                </p>

                <p class="mb-[10px] text-icon-text-medium">
                    V gradnji ali v načrtovanju
                </p>
                <p class="mb-4 text-body-regular">
                    Kasneje pri opisih nepremičnine je v prostem besedilu potreben tudi natančen opis, v kateri fazi je gradnja nepremičnine.
                </p>
                <p class="mb-4 text-body-regular">
                    Pri letu gradnje vnesite leto v katerem je izgradnja nepremičnine z uporabniškim dovoljenjem načrtovana.
                </p>
            </template>
          </v-lightbox>
        </figure>
        <figure class="ml-auto mr-auto w-full max-w-lg">
          <form method="POST" :action="routes.submitForm" id="select-construction-status">
            <v-csrf-token></v-csrf-token>
            <figure>
              <figure
                class="grid grid-cols-1 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-4 lg:gap-6"
              >
                <div
                  name="zgrajeno"
                  :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.bauphase ? 'has-errors' : '')]"
                  v-if="(this.stepData.objektart != 'hausbau' || this.stepData.objektart != 'ind_Schl_3259')"
                >
                  <input
                    type="radio"
                    name="bauphase"
                    id="status-gradnje-1"
                    value="HausFertigGestellt"
                    class="hidden"
                    v-model="constructionPhase"
                    
                  />

                  <label
                    for="status-gradnje-1"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="circle-check" size="5"></v-icon>
                    <span class="pointer-events-none select-none">Zgrajeno</span>
                  </label>
                </div>
                <div
                  name="v-gradnji"
                  :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.bauphase ? 'has-errors' : '')]"
                  v-if="(this.stepData.objektart == 'hausbau' || this.stepData.objektart == 'ind_Schl_3259')"
                >
                  <input
                    type="radio"
                    name="bauphase"
                    id="status-gradnje-2"
                    value="HausImBau"
                    class="hidden"
                    v-model="constructionPhase"
                  />

                  <label
                    for="status-gradnje-2"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="engineering" size="5"></v-icon>

                    <span class="pointer-events-none select-none">V gradnji</span>
                  </label>
                </div>
                <div
                  name="v-nacrtovanju"
                  :class="[
                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', 
                    (validationErrors.bauphase ? 'has-errors' : ''), 
                    ((this.stepData.objektart == 'haus' || this.stepData.objektart == 'wohnung') ? '' : '')]"
                    v-if="(this.stepData.objektart == 'hausbau' || this.stepData.objektart == 'ind_Schl_3259')"
                >
                  <input
                    type="radio"
                    name="bauphase"
                    id="status-gradnje-3"
                    value="HausInPlanung"
                    class="hidden"
                    v-model="constructionPhase"
                  />

                  <label
                    for="status-gradnje-3"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="design-services" size="5"></v-icon>

                    <span class="pointer-events-none select-none"
                      >V načrtovanju</span
                    >
                  </label>
                </div>
              </figure>
              <hr class="mb-11 mt-11" />
              <figure class="ml-auto mr-auto max-w-lg" v-if="constructionPhase == 'HausFertigGestellt'">
                <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-8">
                  <li class="col-span-4">
                    <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.baujahr ? 'has-errors' : '')]">
                      <label
                        for="letoIzgradje"
                        class="w-full text-body-medium-button"
                      >
                        <div class="label flex flex-col gap-[10px]">
                          <div class="flex items-center gap-3">
                            <v-icon icon="calendar-dot-mono" size="4"></v-icon>
                            <span>
                              Leto izgradnje
                              <sup>*</sup></span
                            >
                          </div>
                        </div>
                      </label>
                      <input
                        id="letoIzgradje"
                        type="number"
                        name="baujahr"
                        placeholder="Leto izgradnje"
                        v-model="constructionYear"
                      />
                    </div>
                  </li>
                </ul>
              </figure>
            </figure>
          </form>
        </figure>
      </figure>
    </main>

    <v-add-listing-foot>
      <a
        @click="submitForm('select-construction-status')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      constructionYear: null,
      constructionPhase: null,
    };
  },
  mounted() {
    this.constructionYear = (this.old.baujahr ? this.old.baujahr : this.stepData.baujahr)
    this.constructionPhase = (this.old.bauphase ? this.old.bauphase : this.stepData.bauphase)

    if(!this.constructionPhase && (this.stepData.objektart == 'haus' || this.stepData.objektart == 'wohnung'))  {
      this.constructionPhase = 'HausFertigGestellt';
    }
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
  computed: {
    validated() {
      if(!this.constructionPhase) return false
      
      if(this.constructionPhase == 'HausFertigGestellt') {
        if(!this.constructionYear) return false
      }
      return true;
    }
  },
};
</script>